<script setup lang="ts">
  interface Props {
    href?: string
    color?: string
  }

  withDefaults(defineProps<Props>(), {
    href: undefined,
    color: '#231844',
  })
</script>

<template>
  <component :is="href ? 'a' : 'div'" :href="href" data-test="logo">
    <svg width="76" height="24" viewBox="0 0 76 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.413 1.57037C23.3724 1.57037 25.8491 4.13993 25.8491 7.79644C25.8491 11.611 23.3724 14.2398 17.8774 14.2201C13.2143 14.2201 10.8344 11.2948 10.2539 8.19174H5.62964C5.82307 12.0854 9.98309 15.5049 18.1289 15.5049C26.3328 15.5049 30.454 23.4306 40.554 23.4306C46.3201 23.4306 49.8027 21.5924 52.1631 17.1848H51.2925C49.203 20.0903 47.2679 21.3157 42.7792 21.3157C34.4594 21.3157 30.1831 14.9118 20.412 14.9118V15.1095C28.4998 14.0225 31.2086 11.3344 31.2086 7.79644C31.2086 3.84343 27.4162 0.285721 19.5027 0.285721C15.1492 0.285721 11.7245 1.29371 9.7702 2.61795V3.62594C12.2276 2.40049 14.6655 1.57037 17.413 1.57037ZM41.3086 14.3189V1.47157L45.5653 1.27398V0.483314H31.7311V1.27398L35.9877 1.47157V14.3189L31.7311 14.5166V15.3071H45.5653V14.5166L41.3086 14.3189ZM70.3704 10.9787C67.7388 12.5796 64.3142 13.8247 60.5412 13.8247C54.2337 13.8247 51.4474 11.532 51.4474 7.79644C51.4474 4.13993 54.2142 1.57037 59.8835 1.57037C62.9792 1.57037 65.8041 2.28196 68.4936 3.62594V2.61795C66.4041 1.21464 62.5728 0.285721 57.7936 0.285721C49.8802 0.285721 46.0877 3.84343 46.0877 7.79644C46.0877 12.1448 49.8027 15.5049 58.3356 15.5049C63.1728 15.5049 67.7388 14.0422 70.3704 12.0064V10.9787Z"
        :fill="color"
      />
    </svg>
  </component>
</template>
